export const GET_LCN = 'GET_LCN';

// Get LCN (via saga)
export const getLCN = (locationType = 'input', startLat, startLng) => {
	return {
		type: 'GET_LCN',
		options: {
			locationType,
			startLat,
			startLng
		}
	}
}

// Put LCN (from saga)
export const putLCN = (lcn = []) => {
	return {
		type: 'PUT_LCN',
		payload: {
			lcn,
		}
	}
}

// Clear LCN
export const clearLCN = (lcn = []) => {
	return {
		type: 'CLEAR_LCN',
		payload: {
			lcn,
		}
	}
}



// WEBPACK FOOTER //
// ./src/actions/lcn.js